import { auto, IIntervalService, IPromise, ITimeoutService, IWindowService, ui } from "angular";
import { LogBookService } from 'ng/src/app/core/services/logbook.service';
import { LogBookRootScopeService } from "../shared/model/app.model";
import { ErrorHandlerService } from "../shared/services/error-handler.service";

export class LogoutService {
	private errorHandler!: ErrorHandlerService;
	private loggedError?: boolean;
	private logoutTimeout?: IPromise<void>;
	private promptTimeout?: IPromise<void>;
	private watchExtended!: IPromise<any>;
	private $uibModal!: ui.bootstrap.IModalService;
	private modal!: ui.bootstrap.IModalInstanceService;
	private showingModal = false;
			
	static $inject = ['$rootScope', '$timeout', '$window', '$interval', '$injector', 'logBookService'];
	constructor(
		private $rootScope: LogBookRootScopeService,
		private $timeout: ITimeoutService,
		private $window: IWindowService,
		private $interval: IIntervalService,
		private $injector: auto.IInjectorService,
		private logBookService: LogBookService
	) { }
	
	private get promptTimeoutMs() {
		return parseInt(this.logBookService.getConfigValue('auto-logout.promptTimeoutMs')) || 3000000;
	}
	
	private get logoutTimeoutMs() {
		return parseInt(this.logBookService.getConfigValue('auto-logout.logoutTimeoutMs')) || 3600000;
	}

	private getLastTime(key: string): number | null {
		try {
			let val = this.$window.localStorage.getItem('auto-logout.' + key);

			if (val)
				return parseInt(val);
		}
		catch(e: any) {
			this.logError(e, "Error retrieving logout time from local storage");
		}
		
		return null;
	}

	private writeLastTime(key: string, time: number) {
		try {
			this.$window.localStorage.setItem(`auto-logout.${key}`, time.toString());
		}
		catch (e: any) {
			this.logError(e, "Error saving logout time to local storage");
		}
	}

	private logError(e: Error, msg: string) {
		if (!this.loggedError) {
			console.log("Error retrieving logout time from local storage");
			console.log(e);

			this.loggedError = true;
			this.errorHandler.handle(msg + ": " + e.message, e.stack, false);
		}
	}

	private extendIfUpdated(ifUpdatedFrom: number) {
		let lastExtended = this.getLastTime('lastExtended');

		if (lastExtended && lastExtended > ifUpdatedFrom) {
			this.extendSession(lastExtended);
			return true;
		}

		return false;
	}

	extendSession(fromTime?: number) {
		if(!this.$uibModal)
			this.$uibModal = this.$injector.get('$uibModal');
		if(!this.errorHandler)
			this.errorHandler = this.$injector.get('errorHandler');
		
		let now = new Date().valueOf();

		if (!fromTime)
			fromTime = now;

		if (this.logoutTimeout)
			this.$timeout.cancel(this.logoutTimeout);
		
		let waitForMs = fromTime - now + this.logoutTimeoutMs;

		this.logoutTimeout = this.$timeout(() => {
			if (this.extendIfUpdated(now))
				return;

			this.$rootScope.user && this.$rootScope.logout();
		}, waitForMs);

		if (!this.$rootScope.user || this.showingModal)
			return;

		if (this.promptTimeout)
			this.$timeout.cancel(this.promptTimeout);

		this.promptTimeout = this.$timeout(() => {
			if (!this.$rootScope.user || this.extendIfUpdated(now))
				return;
			
			let lastExtended = this.getLastTime('lastExtended');

			if (lastExtended) {
				this.watchExtended = this.$interval(() => {
					let currentLastExtended = this.getLastTime('lastExtended')

					if (currentLastExtended != lastExtended) {
						this.modal.dismiss();
						this.$interval.cancel(this.watchExtended);

						let lastLogout = this.getLastTime('lastLogout');

						if (lastLogout! >= currentLastExtended! - 5000)
							this.$rootScope.logout();
					}
				}, 100);
			}

			this.showingModal = true;

			this.modal = this.$uibModal.open({
				template: require('./auto-logout-confirm.html'),
			});

			this.modal.result.then(resolved => {
				this.showingModal = false;
				this.$interval.cancel(this.watchExtended!);

				this.writeLastTime('lastLogout', new Date().valueOf());
				this.$rootScope.logout();
			}, rejected => {
				this.showingModal = false;
				this.$interval.cancel(this.watchExtended);
				this.extendSession();
			});
		}, fromTime - now + this.promptTimeoutMs);
		
		if (fromTime == now)
			this.writeLastTime('lastExtended', fromTime);
	}
}

angular.module('logbook').service('logoutService', LogoutService)